import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const LANGUAGES = [
  { code: "fr", label: "Français", short: "FR", flag: "🇫🇷" },
  { code: "en", label: "English", short: "EN", flag: "🇬🇧" },
  { code: "es", label: "Español", short: "ES", flag: "🇪🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "es"],
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "hitmax_lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;

// Audit accessibilité F11 : la langue du document suit celle de l'application.
const syncHtmlLang = (lng) => { try { document.documentElement.lang = (lng || "fr").slice(0, 2); } catch (e) {} };
i18n.on("initialized", () => syncHtmlLang(i18n.language));
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang(i18n.language);
